import * as React from 'react';

import { FeatureFlags } from '~src/ts/FeatureFlags';

import { Messages } from '../../../codegen/Localize';
import { IDataRoleInfo } from '../../../ts/models/IDataRoleInfo';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { MarkupField } from '../Components/MarkupField';
import { LocationField } from './Elements/LocationField';
import { Name } from './Elements/Name';
import { RelatedEntity } from './Elements/RelatedEntity';
import { Timestamp } from './Elements/Timestamp';
import { Tooltip } from './Elements/Tooltip';
import { User } from './Elements/User';
import { ContentTooltipProps, getPersonalSpaceLink,getProjectLink, TooltipDescriptionTestId } from './TooltipHelper';

export function DataRoleTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const projectLink = getProjectLink((props.content as IDataRoleInfo).project, urls);
  const personalSpaceLink = getPersonalSpaceLink(urls);
  const locationType = (props.content as IDataRoleInfo).location?.type;
  const ownerId = content.owner?.id;

  return (
    <Tooltip>
      <Name name={content.name} />
      <MarkupField markup={props.content.description}
                  testId={TooltipDescriptionTestId}
                  extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      {!FeatureFlags.personalSpaceEnabled && !props.inProjectSpace && <RelatedEntity label={Messages.project()} link={projectLink} /> }
      {FeatureFlags.personalSpaceEnabled && <LocationField inProjectSpace={props.inProjectSpace} inPersonalSpace={props.inPersonalSpace} locationType={locationType}
        projectLink={projectLink} personalSpaceLink={personalSpaceLink} contentOwnerId={ownerId}/>}
      <User user={props.content.owner} label={Messages.owner()} urls={urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
